import { CLINIC } from "../../data/content";
import { MessageCircle } from "lucide-react";
import { trackWhatsAppClicked } from "../../lib/analytics";

export default function WhatsAppButton({
  message = "Hello Physio Hyve, I'd like to enquire about physiotherapy.",
  children,
  className = "",
  ...rest
}) {
  const href = `https://wa.me/${CLINIC.whatsapp}?text=${encodeURIComponent(message)}`;
  const onClick = () => {
    trackWhatsAppClicked({
      page_path: typeof window !== "undefined" ? window.location.pathname : "",
      message_preview: message.slice(0, 60),
    });
  };
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-btn"
      onClick={onClick}
      className={`btn-outline ${className}`}
      {...rest}
    >
      <MessageCircle size={16} /> {children || "WhatsApp our clinic"}
    </a>
  );
}
